import IndustriesBanner from './IndustriesBanner'
import IndustryLogistic from './IndustryLogistic'
import { lazy, Suspense } from 'react'

const IndustriesSearvices = lazy(() => import("./IndustriesSearvices"));
const IndustriesDesign = lazy(() => import("./IndustriesDesign"));
const IndustryTransform = lazy(() => import("./IndustryTransform"));
const IndustryHighEnd = lazy(() => import("./IndustryHighEnd"));
const IndustryNeed = lazy(() => import("./IndustryNeed"));
const WhiteMobilize = lazy(() => import("../WhiteLabelSolutions/WhiteMobilize"));
const ShuttleAppreciation = lazy(() => import("../shuttle_software/ShuttleAppreciation"));
const ShuttleItNeed = lazy(() => import("../shuttle_software/ShuttleItNeed"));
const IndustryPricing = lazy(() => import("./IndustryPricing"));
const TaxiFaq = lazy(() => import("../taxiDispatchSoftware/TaxiFaq"));

const faqData = [
  {
    id: "0",
    question: "01. Do you work with existing transportation and logistics software, or only develop solutions from scratch?",
    answer: "We do both. Our team can enhance and integrate with your existing software or create custom solutions from scratch, tailored to meet your specific business requirements.",
  },
  {
    id: "1",
    question: "02. How much does it cost to develop custom logistics software?",
    answer: "The cost varies based on the complexity, features, and scale of the project. We provide a detailed quote after understanding your needs and project scope.",
  },
  {
    id: "2",
    question: "03. What role does user experience (UX) design play in logistics and transportation software products?",
    answer: "UX design is critical as it ensures the software is intuitive and user-friendly, reducing errors, improving productivity, and enhancing satisfaction for both internal users and customers.",
  },
  {
    id: "3",
    question: "04. Can you develop SaaS software for the logistics industry?",
    answer: "Yes, we specialize in developing SaaS-based logistics solutions that provide scalability, flexibility, and easy access from anywhere, enabling seamless operations for businesses of all sizes.",
  },
  {
    id: "4",
    question: "05. How long does it take a transport firm to develop logistics software?",
    answer: "The timeline depends on the project’s scope and complexity. On average, it may take anywhere from 3 to 12 months, including planning, development, testing, and deployment.",
  },
  {
    id: "5",
    question: "06. Why do transportation companies need logistics solutions for their business?",
    answer: "Logistics solutions improve operational efficiency, optimize routes, reduce costs, enhance customer satisfaction, and provide valuable analytics to scale and grow the business effectively.",
  }
];

export default function Industries() {
  return (
    <>
      <IndustriesBanner />
      <IndustryLogistic />

      <Suspense fallback={null}>
        <IndustriesSearvices />
        <IndustriesDesign />
        <IndustryHighEnd />
        <IndustryTransform />
        <IndustryNeed />
        <WhiteMobilize />
        <IndustryPricing />
        <ShuttleAppreciation />
        <ShuttleItNeed />
        <TaxiFaq faqData={faqData} />
      </Suspense>
    </>
  )
}
